export interface VendorsFeatureRoutesConfig {
  path: string;
}

export const defaultVendorsFeatureRoutesConfig: VendorsFeatureRoutesConfig = {
  path: 'vendors',
};
